<template>
  <div class="loginmain" id="particles-js">
    <div class="model"></div>
    <div class="login" id="login">
      <h3>登录</h3>
      <ul class="log-form">
        <li>
          <i class="name"></i>
          <input type="text" placeholder="请输入用户名" v-model="username" onfocus="this.placeholder=''"
            onblur="this.placeholder='请输入用户名'">
          <label for="">用户名</label>
        </li>
        <li>
          <i class="password"></i>
          <input type="password" placeholder="请输入密码" v-model="password" onfocus="this.placeholder=''"
            onblur="this.placeholder='请输入密码'">
          <label for="">密码</label>
        </li>
      </ul>
      <div class="login-button" @click="gologin">登录</div>
    </div>
    <div class="rotating-plane " id="shape"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: '',
  components: {},
  data() {
    return {
      pagemenu: 'chome',
      username: '',
      password: ''
    }
  },
  mounted() {


  },
  methods: {
    gologin() {
      if (this.username == 'sbuser' && this.password == 'sb13579') {
        this.$message.success('登录成功')
        window.localStorage.setItem('sbtoken', 'as3uuiefhsdjbfjSF24WD$345423ue78r738')
        this.$router.push('/')
      } else {
        this.$message.error('账号密码错误')
      }

    }
  },
}
</script>

<style scoped>
@import '../assets/css/reset.css';
@import '../assets/css/login.css';

.loginmain {
  height: 100%;
  width: 100%;

  overflow: hidden;

  .model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('../assets/img/bg.png');
    background-size: 100% 100%;
    z-index: 1;
  }
}
</style>
